export default [
  {
    position: "absolute",
    top: 7.6,
    left: 14,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 7,
    tooltipText: "performanceObjectivesP2.ttTextOne",
    hover: false,
    id: "SP_Performance_Navigation_Performance",
    index: 0,
  },
  {
    position: "absolute",
    top: 15.3,
    left: 12.5,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 17,
    tooltipText: "performanceObjectivesP2.ttTextTwo",
    hover: false,
    id: "SP_Performance_Navigation_Performance_Feedback",
    index: 1,
  },
  {
    position: "absolute",
    top: 40,
    left: 49.4,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "performanceObjectivesP2.mTitleOne",
    mBody: "performanceObjectivesP2.mBodyOne",
    id: "SP_Performance_Info_Objectives",
    infoIcon: true,
    isAction: false,
    index: 2,
  },
];
